import { pathAssets } from '@/globals/globalvariables'
import type { LoaderDataTypes } from '@powerplay/core-minigames'
import { ModelsNames } from '../types'

// Hlavny priecinok s modelmi
const modelsDir = `${pathAssets}/models/`

/**
 * Konfig pre modely
 */
export const modelsConfig: LoaderDataTypes = {
  [ModelsNames.skier]: {
    version: 8,
    femaleVersion: 5,
    ext: 'glb',
    genderActive: true,
    dir: modelsDir,
    mainMeshNames: [ModelsNames.skier],
    frustumNotCulled: true
  },
  [ModelsNames.hill]: {
    version: 32,
    ext: 'glb',
    dir: modelsDir
  },
  [ModelsNames.idealTrackIndicator]: {
    version: 2,
    ext: 'glb',
    dir: modelsDir
  },
  [ModelsNames.trackLines]: {
    ext: 'glb',
    dir: modelsDir
  }
}
